import React from 'react';

import type { OralExamRunStateResponse } from '@/common/api/models/oralExamRunStateResponse';
import { OralExamSessionPhase } from '@/common/api/models/oralExamSessionPhase';

import { ConsentStep } from './ConsentStep';
import { IdVerificationStep } from './IdVerificationStep';

export const ORAL_EXAM_CONSENT_POLICY_VERSION = '2026-06';
export const ORAL_EXAM_CONSENT_SCOPE = 'recording_and_id_verification';
export const ORAL_EXAM_CONDUCT_POLICY_VERSION = '2026-07-conduct-v1';

export type OralExamPreFlightStepsProps = {
  runState: OralExamRunStateResponse;
  onRecordConsent: () => void;
  onUploadIdPhoto: (imageBase64: string) => void;
  isRecordingConsent?: boolean;
  isUploadingIdPhoto?: boolean;
};

/** Consent -> ID capture sequence within pre_flight (plain Slice C wiring). */
export function OralExamPreFlightSteps({
  runState,
  onRecordConsent,
  onUploadIdPhoto,
  isRecordingConsent = false,
  isUploadingIdPhoto = false,
}: OralExamPreFlightStepsProps) {
  if (runState.sessionPhase !== OralExamSessionPhase.pre_flight) {
    return null;
  }

  if (!runState.consentRecord) {
    return (
      <ConsentStep
        onAccept={onRecordConsent}
        isSubmitting={isRecordingConsent}
        policyVersion={ORAL_EXAM_CONSENT_POLICY_VERSION}
      />
    );
  }

  return (
    <IdVerificationStep
      mode="document"
      onCapture={onUploadIdPhoto}
      isSubmitting={isUploadingIdPhoto}
      submitted={Boolean(runState.idPhotoBlobPath && runState.idSelfiePhotoBlobPath)}
    />
  );
}
